import { render, staticRenderFns } from "./VitalSignRecord.vue?vue&type=template&id=7b836306"
import script from "./VitalSignRecord.vue?vue&type=script&lang=js"
export * from "./VitalSignRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports